export default __webpack_public_path__ + "static/media/group.38306c2c.png";